<template>
  <Legacy
    view="rates"
    action="ratesCustomerQuote"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'Quote',
      breadcrumb: {
        name: 'Quote',
        route: { name: 'freight-quote' }
      }
    }
  }
}
</script>
